import axios from 'axios';
import { getDecryptedToken } from './tokenStorage';



/* const baseURL = import.meta.env.VITE_API_BASE_URL; //Local Testing  */  

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


api.interceptors.request.use((config) => {
  const accessToken = getDecryptedToken('accessToken');
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

export default api;
